import { render, staticRenderFns } from "./VendorPicker.vue?vue&type=template&id=28638502&scoped=true&"
import script from "./VendorPicker.vue?vue&type=script&lang=js&"
export * from "./VendorPicker.vue?vue&type=script&lang=js&"
import style0 from "./VendorPicker.vue?vue&type=style&index=0&id=28638502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28638502",
  null
  
)

export default component.exports